// extracted by mini-css-extract-plugin
export default {"backForwardSection":"styles_backForwardSection__6hBF5","arrow":"styles_arrow__fWqeQ","backForwardText":"styles_backForwardText__pwKTy"};